import styled from "styled-components";

import awardBg from '@/images/everyday-award-bg.png'
import awardBgHover from '@/images/everyday-award-bg-hover.png'
// import awardBg1 from '@/images/everyday-award-bg-01.png'
// import awardBg1Hover from '@/images/everyday-award-bg-01-hover.png'
// import awardBg2 from '@/images/everyday-award-bg-02.png'
// import awardBg2Hover from '@/images/everyday-award-bg-02-hover.png'
// import awardBg3 from '@/images/everyday-award-bg-03.png'
// import awardBg3Hover from '@/images/everyday-award-bg-03-hover.png'

import tip from '@/images/everyday-tip.png'

const View = styled.div`
  position: absolute;
  left: -2px;
  top: 11px;
  width: 440px;
  height: 470px;
  text-align: center;

  span.changeGame {
    display: inline-block;
    position: absolute;
    right: 80px;
    top: 25px;
    font-size: 16px;
    text-decoration: underline;
    color: #852b03;
    cursor: pointer;
  }

  p.probabilityTip {
    position: absolute;
    left: 50%;
    top: 38px;
    width: 290px;
    transform: translateX(-50%);
    font-size: 14px;
    text-shadow: 0 0 #852b03;
    color: #4e98f3;
  }

  p.taskName {
    position: absolute;
    left: 50%;
    top: 58px;
    transform: translateX(-50%);
    font-size: 20px;
    font-weight: bold;
    color: #4e98f3;
    // text-shadow: 1px 1px 4px #852b03, -1px -1px 4px #852b03;
  }

  p.tipTxt {
    position: absolute;
    left: 50%;
    top: 90px;
    transform: translateX(-50%);
    font-size: 14px;
    color: #4e98f3;

    span {
      display: inline-block;
      vertical-align: middle;
      height: 16px;
      width: 16px;
      border-radius: 50%;
      border: 1px solid #4e98f3;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      margin-left: 6px;
      cursor: pointer;
    }
  }

  ul {
    margin-top: 115px;
    width: 100%;
    height: 210px;
    text-align: center;

    li {
      display: inline-block;
      margin: 0 2px;
      width: 143px;
      height: 214px;
      position: relative;
      cursor: pointer;
      transition: all 0.15s;

      &:nth-child(1) {
        background-image: url("${awardBg}");
        &:hover,
        &.active {
          background-image: url("${awardBgHover}");
        }
      }

      &:nth-child(2) {
        margin-left: -12px;
        background-image: url("${awardBg}");
        &:hover,
        &.active {
          background-image: url("${awardBgHover}");
        }
      }

      &:nth-child(3) {
        margin-left: -12px;
        background-image: url("${awardBg}");
        &:hover,
        &.active {
          background-image: url("${awardBgHover}");
        }
      }

      img {
        width: 78px;
        height: 78px;
        position: absolute;
        left: 50%;
        top: 45px;
        transform: translateX(-50%);
      }

      p {
        font-size: 16px;
        color: #ffffff;
        font-weight: bold;
        position: absolute;
        bottom: 31px;
        width: 100%;
      }
    }
  }

  .button {
    margin-top: 25px;
  }
`;
const ToolRule = styled.div`
  width: 289px;
  height: 210px;
  background-image: url(${tip});
  position: absolute;
  left: -60px;
  top: -50px;
`

export {
  View,
  ToolRule
}
